import { DatabaseCode, toDatabaseCode, toDatabaseCodeSafely } from "./database-code";


export type IntegrationStatus = DatabaseCode;

const failure: IntegrationStatus = {
  code: 'FAILURE',
  displayValue: {
    id: 'ots.ui.entity.integrationstatus.failure',
    defaultMessage: 'Failure',
  },
};

const success: IntegrationStatus = {
  code: 'SUCCESS',
  displayValue: {
    id: 'ots.ui.entity.integrationstatus.success',
    defaultMessage: 'Success',
  },
};

export const integrationStatus = {
  failure,
  success,
};

export const integrationStatuses = Object.values(integrationStatus);

export const toIntegrationStatus = (code: string): IntegrationStatus => toDatabaseCode(code, integrationStatuses);
export const toIntegrationStatusSafely = (code: string | undefined): IntegrationStatus | undefined => toDatabaseCodeSafely(code, integrationStatuses);
